document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  setupPublicHeaderMenu();
  setupPublicHeaderDropdown();
  markActivePublicNav();
});

function setupPublicHeaderMenu() {
  const btn = document.getElementById("headerMenuBtn");
  const nav = document.getElementById("headerMainNav");

  if (!btn || !nav) return;

  btn.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");

    btn.classList.toggle("is-active", isOpen);
    btn.setAttribute("aria-expanded", String(isOpen));
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      if (link.closest("#headerCrgrDropdown")) return;

      if (window.innerWidth <= 920) {
        nav.classList.remove("is-open");
        btn.classList.remove("is-active");
        btn.setAttribute("aria-expanded", "false");
      }
    });
  });
}

function setupPublicHeaderDropdown() {
  const dropdown = document.getElementById("headerCrgrDropdown");
  const toggle = document.getElementById("headerCrgrToggle");
  const submenu = document.getElementById("headerCrgrSubmenu");
  const nav = document.getElementById("headerMainNav");

  if (!dropdown || !toggle || !submenu) return;

  function forceOpenStyles() {
    submenu.style.display = "grid";
    submenu.style.opacity = "1";
    submenu.style.visibility = "visible";
    submenu.style.pointerEvents = "auto";
    submenu.style.transform = "translateY(0)";
    submenu.style.zIndex = "999999";
  }

  function clearOpenStyles() {
    submenu.style.display = "";
    submenu.style.opacity = "";
    submenu.style.visibility = "";
    submenu.style.pointerEvents = "";
    submenu.style.transform = "";
    submenu.style.zIndex = "";
  }

  function closeDropdown() {
    submenu.classList.remove("is-open");
    dropdown.classList.remove("is-open");
    toggle.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    clearOpenStyles();
  }

  function openDropdown() {
    submenu.classList.add("is-open");
    dropdown.classList.add("is-open");
    toggle.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    forceOpenStyles();
  }

  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();

    const isOpen = submenu.classList.contains("is-open");

    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  submenu.addEventListener("click", (event) => {
    event.stopPropagation();
  });

  document.addEventListener("click", (event) => {
    if (!dropdown.contains(event.target)) {
      closeDropdown();
    }
  });

  submenu.querySelectorAll(".header-nav-sublink").forEach((link) => {
    link.addEventListener("click", () => {
      closeDropdown();

      if (window.innerWidth <= 920 && nav) {
        nav.classList.remove("is-open");

        const btn = document.getElementById("headerMenuBtn");

        if (btn) {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-expanded", "false");
        }
      }
    });
  });

  window.addEventListener("resize", () => {
    const btn = document.getElementById("headerMenuBtn");

    if (window.innerWidth > 920) {
      if (nav) nav.classList.remove("is-open");

      if (btn) {
        btn.classList.remove("is-active");
        btn.setAttribute("aria-expanded", "false");
      }

      closeDropdown();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDropdown();
    }
  });
}

function markActivePublicNav() {
  const path = window.location.pathname.split("/").pop() || "index.html";
  const hash = window.location.hash || "";

  const map = {
    "index.html": "index",
    "quem-somos.html": "quem-somos",
    "login.html": "login"
  };

  const subMap = {
    "vila-pinto.html": "vila-pinto",
    "cooadesc.html": "cooadesc",
    "padre-cacique.html": "padre-cacique"
  };

  let activeKey = map[path] || "index";
  const activeSubKey = subMap[path];

  if ((path === "index.html" || path === "") && hash === "#indicadores") {
    activeKey = "indicadores";
  }

  if ((path === "index.html" || path === "") && hash === "#faq") {
    activeKey = "faq";
  }

  document.querySelectorAll(".header-nav-link").forEach((link) => {
    link.classList.toggle("is-active", link.dataset.nav === activeKey);
  });

  document.querySelectorAll(".header-nav-sublink").forEach((link) => {
    link.classList.toggle("is-active", link.dataset.navSub === activeSubKey);
  });

  if (activeSubKey) {
    const dropdown = document.getElementById("headerCrgrDropdown");
    const toggle = document.getElementById("headerCrgrToggle");

    if (dropdown) dropdown.classList.add("has-active-child");
    if (toggle) toggle.classList.add("is-active");
  }
}